module.exports = __webpack_public_path__ + "static/media/lg-ars-fab-horse.220f4e16.jpg";